import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기-header 컴포넌트
 *
 ********************************************************************/
import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { checkTypeState, noneUrl } from "../../../../recoil/assessmentState";
// utils
import * as CUTIL from "../../../../utils/commUtils";
import dayjs from "dayjs";
import { useTrans } from "../../../../utils/langs/useTrans";
function CheckHeader(props) {
    const t = useTrans();
    // recoil
    const check = useRecoilValue(checkTypeState);
    // porps
    const { handleOpenPop } = props;
    useEffect(() => {
        // 진단하기 나가기
        handleOpenPop("pop-check-close", _jsx(CheckClosePop, {}));
    }, []);
    function CheckClose(e) {
        CUTIL.jsopen_Popup(e);
    }
    return (_jsx(_Fragment, { children: _jsxs("header", { children: [_jsx("div", Object.assign({ className: "header__left" }, { children: _jsxs("h1", Object.assign({ className: "header__title" }, { children: [_jsx("strong", { children: `${t("라벨.형명")} : ${check.itemInfo.itemName}` }), _jsxs("span", { children: [t("라벨.시리얼번호"), ": ", check.itemInfo.serialNo] })] })) })), _jsxs("div", Object.assign({ className: "header__right" }, { children: [_jsxs("ul", Object.assign({ className: "header__etc" }, { children: [_jsx("li", Object.assign({ className: "date" }, { children: dayjs(new Date()).format("YYYY-MM-DD") })), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-close js-open", "data-pop": "pop-check-close", onClick: (e) => CheckClose(e) }, { children: t("라벨.나가기") })) })] })), _jsx("div", Object.assign({ className: "header__logo" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "LS" })) }))] }))] }) }));
}
export default CheckHeader;
function CheckClosePop() {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    function CheckListClose(e) {
        setCheck(Object.assign(Object.assign({}, check), { checkOn: false, nextStep: "", preStep: "", assessmentId: -1, checkitemId: -1, preCheckitemId: -1, checkvalueId: -1, itemNum: -1, totalComment: "", itemInfo: {
                id: -1,
                itemId: "",
                itemName: "",
                panelName: "",
                serialNo: "",
                spgId: -1,
            }, chekTypeInfo: {
                checkTypeId: -1,
                checkTypeName: "",
            }, chekSubTypeInfo: {
                checkSubTypeId: -1,
                checkSubName: "",
            }, chekVersionTypeInfo: {
                checkVersionId: -1,
                versionNo: "",
            }, assessmentInfo: {
                isTempSave: check.assessmentInfo.isTempSave,
                reportId: -1,
            }, checkvalue: {
                action: "",
                comment: "",
                input: -1,
                isChecked: false,
                value: -1,
            }, listType: -1, startPage: -1, endpage: -1, dueDate: "", instrument: -1, countOpenClose: -1, treeName: "", schdeulerId: -1, disabled: false, inspector: "" }));
        setRecoilNoneUrlInfo(true);
        CUTIL.jsclose_Popup("pop-check-close");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("p", { children: [check.checkitemId >= 0 ? t("라벨.점검이완료되지않았습니다") : t("라벨.나가시겠습니까"), " ", _jsx("br", {}), check.checkitemId >= 0 ? t("라벨.페이지벗어날경우") : ""] }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-check-close") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => CheckListClose(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
